import { Alert, AlertProps, AlertPropsVariantOverrides, AlertTitle, AlertTitleProps } from '@mui/material'
import { OverridableStringUnion } from '@mui/types'
import { FC } from 'react'

export type C1AlertSeverityType = 'primary' | 'info' | 'error' | 'warning' | 'success'

export type C1AlertVariantType = OverridableStringUnion<
    'outlined' | 'standard' | 'banner' | 'form',
    AlertPropsVariantOverrides
>

export type C1AlertTitleProps = AlertTitleProps
export type C1AlertProps = Omit<AlertProps, 'color' | 'variant' | 'severity'> & {
  variant?: C1AlertVariantType,
  severity?: C1AlertSeverityType,
}

declare module '@mui/material/Alert' {
    export interface AlertPropsColorOverrides {
        primary: true
    }

    export interface AlertPropsVariantOverrides {
        banner: true
        form: true
    }
}

export const C1AlertTitle: FC<C1AlertTitleProps> = (props) => <AlertTitle {...props} />

export const C1Alert: FC<C1AlertProps> = ({ severity: _severity, icon, ...rest }) => {
    let severity: AlertProps['severity']
    let color: AlertProps['color']

    // MUI doesn't let you extend the 'severity' types. :(
    switch (_severity) {
        case 'primary':
            color = 'primary'
            severity = 'info'
            break
        default:
            color = _severity || 'info'
            severity = _severity || 'info'
            break
    }

    return <Alert
        color={color}
        severity={severity}
        icon={icon}
        {...rest}
    />
}
